import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {Make} from "./make";
import {Category} from "./category";
import {Subcategory} from "./subcategory";
import {EngineType} from "./engine-type";
import * as JSONMapper from "json-mapper";

export class ModelSummary extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty()
	name: string;

	@jsonProperty()
	pricingTier: number;

	@jsonProperty()
	warrantyCode: string;

	@jsonProperty()
	serialNumFormat: string;

	@jsonProperty()
	popularName: string;

	@jsonProperty()
	icaoType: string;

	@jsonProperty()
	imageUrl: string;

	@jsonProperty()
	legacyModelId: number;

	@jsonProperty(JSONMapper.classByMethods(Make))
	make: Make;

	@jsonProperty(JSONMapper.classByMethods(Category))
	category: Category;

	@jsonProperty(JSONMapper.classByMethods(Subcategory))
	subcategory: Subcategory;

	@jsonProperty(JSONMapper.classByMethods(EngineType))
	engineType: EngineType;

	constructor(data?: Partial<ModelSummary>) {
		super();
		Object.assign(this, data);
	}
}
